import auth from './auth.json';

export { auth };
